import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 108 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C.jsx("g", { clipPath: "url(#clip0_14423_202183)", children: /* @__PURE__ */ C.jsx(
    "path",
    {
      clipPath: "evenodd",
      clipRule: "evenodd",
      d: "M83.3639 30.4203V30.4169C83.1714 30.4309 82.1791 30.4903 79.9654 30.4903C78.1979 30.4903 76.9536 30.4379 76.5161 30.4169V30.4221C69.7121 30.1229 64.6336 28.9381 64.6336 27.5206C64.6336 26.1048 69.7121 24.9201 76.5161 24.6156V29.2426C76.9606 29.2741 78.2346 29.3493 79.9951 29.3493C82.1074 29.3493 83.1661 29.2619 83.3639 29.2444V24.6191C90.1539 24.9218 95.2201 26.1066 95.2201 27.5206C95.2201 28.9381 90.1539 30.1193 83.3639 30.4203ZM83.3639 24.1379V19.9974H92.8384V13.6833H67.0416V19.9974H76.5161V24.1361C68.8161 24.4896 63.0254 26.0156 63.0254 27.8426C63.0254 29.6696 68.8161 31.1938 76.5161 31.5491V44.8176H83.3639V31.5456C91.0516 31.1921 96.8284 29.6678 96.8284 27.8426C96.8284 26.0173 91.0516 24.4931 83.3639 24.1379Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ C.jsx("rect", { x: "54", y: "2", width: "52", height: "52", rx: "26", stroke: "currentColor", strokeWidth: "4" }),
  /* @__PURE__ */ C.jsxs("g", { clipPath: "url(#clip1_14423_202183)", children: [
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M27.9997 0.00439453C12.538 0.00439453 0.00390625 12.5385 0.00390625 28.0002C0.00390625 43.4618 12.538 55.9959 27.9997 55.9959C43.4613 55.9959 55.9954 43.4618 55.9954 28.0002C55.9954 12.5385 43.4613 0.00439453 27.9997 0.00439453ZM27.9997 52.6834C23.1178 52.6834 18.3456 51.2357 14.2864 48.5235C10.2272 45.8113 7.06356 41.9563 5.19534 37.4461C3.32713 32.9357 2.83831 27.9727 3.79072 23.1847C4.74314 18.3966 7.09398 13.9985 10.5459 10.5464C13.998 7.09448 18.3961 4.74363 23.1843 3.79122C27.9723 2.83882 32.9352 3.32762 37.4456 5.19583C41.9558 7.06406 45.8108 10.2277 48.523 14.2869C51.2352 18.346 52.6829 23.1183 52.6829 28.0002C52.6829 34.5466 50.0824 40.8249 45.4533 45.4538C40.8244 50.0829 34.5461 52.6834 27.9997 52.6834Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M26.6718 25.996L13.6367 39.59H18.3886L27.9996 29.9796L37.6107 39.59H42.3626L29.3276 25.996C29.1532 25.8216 28.9462 25.6832 28.7183 25.5889C28.4905 25.4944 28.2463 25.4458 27.9996 25.4458C27.753 25.4458 27.5088 25.4944 27.2809 25.5889C27.0532 25.6832 26.8462 25.8216 26.6718 25.996Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M21.0713 20.0036H27.9858C33.1919 20.0036 35.9174 22.3586 35.9174 26.4889C35.9344 27.593 35.6798 28.6845 35.1759 29.6671L38.1311 32.4466C39.3273 30.8582 39.9848 28.8543 39.9848 26.4889C39.9848 20.2104 35.5102 16.4102 28.1079 16.4102H17.0039V32.7629L21.0713 28.4373V20.0036Z",
        fill: "currentColor"
      }
    )
  ] })
] });
export {
  r as R
};
